import {useToast} from '@/shared/components/toast/useToast';
import {useUserStore} from '@/stores/userStore';

// Debug aid: superadmins can visualize tracked license_activity events (both the
// frontend-emitted and the backend-mirrored ones) as toasts by setting this
// sessionStorage key to 'true' (non-persistent, cleared when the browser session ends).
export const LICENSE_EVENT_VISUALIZATION_KEY = 'visualizeLicenseEvents';

export function isLicenseEventVisualizationEnabled(): boolean {
    return window.sessionStorage.getItem(LICENSE_EVENT_VISUALIZATION_KEY) === 'true';
}

export function setLicenseEventVisualizationEnabled(enabled: boolean): void {
    if (enabled) {
        window.sessionStorage.setItem(LICENSE_EVENT_VISUALIZATION_KEY, 'true');
    } else {
        window.sessionStorage.removeItem(LICENSE_EVENT_VISUALIZATION_KEY);
    }
}

export function visualizeTrackingEvent(summary: string, label: string): void {
    if (!isLicenseEventVisualizationEnabled() || !useUserStore().isSuperAdmin) {
        return;
    }

    useToast().success(summary, {detail: label, life: 10000});
}
